/*
 * @Author: mikey.zhaopeng
 * @Date: 2021-07-02 17:39:57
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2021-07-07 09:24:17
 */

/**
 *  公共参数类型校验 prop-types，类型命名以I开头
 */
import PropTypes from "prop-types";

// ------ YxText 组件类型
export const IYxTextType = PropTypes.oneOf([
  "String",
  "Number",
  "Time",
  "Tag",
  "Icon",
  "Status",
  "Progress",
  "Img",
]);

//-------样式类型约束

export const IStyleParam = PropTypes.shape({
  size: PropTypes.string,
  type: PropTypes.string,
  width: PropTypes.string,
});

//--------- 接口类型约束---------
export const IYxrequestType = {
  // 接口请求的地址
  url: PropTypes.string.isRequired,

  //接口请求的参数
  data: PropTypes.object,

  //接口请求类型
  method: PropTypes.oneOf(["post", "get", "put", "delete"]),

  //请求头
  headers: PropTypes.object,

  //接口请求成功后的回调函数
  callback: PropTypes.func,

  // 当此参数存在时，请求接口将 被外部控制，需要返回一个与接口结构一致的值来
  intercept: PropTypes.func,

  // 当指定 searchPath 时，将会把查询面板的表单参数放入此字段请求  比如searchPath="filter"
  searchPath: PropTypes.string,

  //开启指令模式，会对所有参数中指令进行匹配
  yxCommand: PropTypes.bool,

  //filterEmpty开启后，函数默认会过滤 undefined, null, '', [] 这些值，
  //如果有特殊的字段需要保留，则传入handle函数 并且返回true
  filterEmpty: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),

  //请求开始前，data的处理函数，在映射完模型后执行
  beforeRequest: PropTypes.func,

  //response的处理函数，在映射完模型后执行
  afterRequest: PropTypes.func,

  // 接口请求失败调用
  failure: PropTypes.func,

  // 请求参数的数据模型，最终的请求数据以该模型映射后的结果为准
  // 除了age和id字段外，其它字段将会被删掉: {age:'list.age',ids:'id'}
  //除了age和id字段外，其它字段都不会被修改:
  //[{target:'list.age',source:'age',activeTarget: '动态key值'},
  //{target:'list.id',source:'id',activeTarget: '动态key值'}]
  requestModel: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),

  //*为true时将会自动将类型为数组的值用 joinMark（默认为英文逗号,）
  //字段连接起来变成字符串，比如a=[1,2,3] 变成  a=1,2,3
  joinArray: PropTypes.bool,

  //消息处理逻辑，为true时，组件默认提示接口返回的值，false不使用组件内置的消息，可传入函数
  message: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
};

export const IYxrequest = PropTypes.shape(IYxrequestType);



// WEBPACK FOOTER //
// ./src/yx-widget/utils/propType.js